// extracted by mini-css-extract-plugin
export default {"sdg":"CauseAreaCell_sdg__1cPZR"};